import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { LOG_LOCATION } from './constants.tsx';
import type { State } from './types.tsx';

// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const FALLBACK_CHILD_ISSUES_LIMIT = 500 as const;

const getFallbackChildIssuesLimitAndLogAsUnexpected = () => {
	log.safeErrorWithoutCustomerData(
		`${LOG_LOCATION}.selectors.getChildIssuesLimit`,
		'The child issues limit is undefined using the fallback child issues limit',
	);

	return FALLBACK_CHILD_ISSUES_LIMIT;
};

export const getChildIssuesLimit = (state: State) =>
	state.childIssuesLimit ?? getFallbackChildIssuesLimitAndLogAsUnexpected();
export const getChildIssuesIssueLimitUrls = (state: State) => state.childIssuesIssueLimitUrls;
